import LaptopIcon from './LaptopIcon';
export default LaptopIcon;
